import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted Schriften (gegen DSGVO-Risiko durch Google-Fonts-CDN).
// Wir laden nur die tatsaechlich genutzten Schnitte, damit die Bundle-Groesse
// klein bleibt.
// Inter: Body und UI-Elemente (Sans-Serif)
// Source Serif 4: Ueberschriften (font-display) - klassische, ruhige
// Antiqua, die zum Traditionsverein passt ohne ornamental zu werden.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/source-serif-4/500.css';
import '@fontsource/source-serif-4/600.css';
import '@fontsource/source-serif-4/700.css';
import '@/index.css';
import App from '@/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
